// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"e763ab82","472":"5bd7bf90"}[chunkId] + ".chunk.js";
};